import ReplayAction from "./ReplayAction";
import {
  SessionType,
  GameSpecialty,
  GameStructure,
  GameVariant,
} from "./ReplayVariables";

class ReplayHand {
  id = "";
  roomType = "";
  sessionName = "";
  sessionType = SessionType.TOURNAMENT;
  gameSpecialty = GameSpecialty.FREEZEOUT_TYPE;
  gameStructure = GameStructure.NORMAL;
  gameVariant = GameVariant.NO_LIMIT_HOLD_EM;
  handNum = 0;
  table = 1;
  smallBlind = 0;
  bigBlind = 0;
  ante = 0;
  potSize = 0;
  currency = null;
  nbSeats = 0;
  nbSeatsForReplayer = 0;
  buttonSeat = 0;
  startDate;
  actions = [];
  hero = "";
  anonymous = false;
  showAllCards = false;
  background = "";
  table = "";

  views = 0;
  user_id = 0;
  user_name = "";
  subscribed = false;
  visibility = 1;
  nb_comments = 0;
  comments = [];

  related = [];

  statistics = {};

  sessionHands;

  mtt = false;

  getActions() {
    return this.actions;
  }

  getAction(index) {
    return this.getActions()[index];
  }

  static from(json)
  {
    let hand = new ReplayHand();
    Object.assign(hand, json);
    let _actions = [];
    hand.actions.forEach((_action) =>
    {
      let action = ReplayAction.from(_action);
      _actions.push(action);
      //step.firstActionIndex = _actions.length - 1;
    });
    hand.actions = _actions;
    if (hand.sessionHands)
    {
      let _sessionHands = [];
      let oldSessionHands = hand.sessionHands;
      delete hand.sessionHands;
      _sessionHands.push(this.from(hand));
      oldSessionHands.forEach(h =>
      {
        let _h = ReplayHand.from(h);
        _h.id += 1;
        _sessionHands.push(_h);
      });
      hand.sessionHands = _sessionHands;
    }
    return hand;
  }
}

export default ReplayHand;
